import { render, staticRenderFns } from "./SkupKotizacijaBase.vue?vue&type=template&id=136b9fd8&scoped=true&"
import script from "./SkupKotizacijaBase.vue?vue&type=script&lang=js&"
export * from "./SkupKotizacijaBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136b9fd8",
  null
  
)

export default component.exports